import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const NAV_GROUPS = [
  {
    label: "くじ結果一覧",
    items: [
      { to: "/loto6",    label: "ロト6" },
      { to: "/loto7",    label: "ロト7" },
      { to: "/miniloto", label: "ミニロト" },
      { to: "/numbers4", label: "ナンバーズ4" },
      { to: "/numbers3", label: "ナンバーズ3" },
      { to: "/bingo5",   label: "ビンゴ5" },
      { to: "/qoochan",  label: "着せかえクーちゃん（販売終了）" },
    ],
  },
  {
    label: "統計データ",
    items: [
      { to: "/loto6/stats",    label: "ロト6 統計" },
      { to: "/loto7/stats",    label: "ロト7 統計" },
      { to: "/miniloto/stats", label: "ミニロト 統計" },
      { to: "/numbers4/stats", label: "ナンバーズ4 統計" },
      { to: "/numbers3/stats", label: "ナンバーズ3 統計" },
      { to: "/bingo5/stats",   label: "ビンゴ5 統計" },
      { to: "/qoochan/stats",  label: "着せかえクーちゃん 統計" },
    ],
  },
  {
    label: "その他",
    items: [
      { to: "/news",      label: "お知らせ" },
      { to: "/about",     label: "このサイトについて" },
      { to: "/privacy",   label: "プライバシーポリシー" },
      { to: "/terms",     label: "免責事項" },
      { to: "/changelog", label: "更新履歴" },
    ],
  },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const handleClose = () => setIsOpen(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <header className="bg-primary-500 text-base-50 relative z-50">
      <div className="container max-w-7xl mx-auto px-8 max-[360px]:px-4 py-4 flex justify-between items-center relative z-50 h-16">
        <h1 className="text-xl font-bold">
          <Link to="/" onClick={handleClose} className="relative block">
            <div className="font-['Gravitas_One'] select-none text-[7px] absolute -top-2 right-5 space-x-2">
              ChatoraHack
            </div>
            <div className="flex justify-start items-end gap-0">
              <motion.span 
                className="relative flex items-center justify-center w-12 h-12"
                initial={{ rotate: 30 }}
                animate={{ rotate: -30 }}
                transition={{ duration: 4, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
              >
                <svg viewBox="286 350 929 800" className="absolute inset-0 w-full h-full" aria-hidden="true">
                  <path
                    d="M1181.35,943.37c-32.38,96.66-119.02,146.27-213.95,169.16-36.26,8.74-72.21,14.23-109.58,17.21-68.48,5.47-136.53,5.65-205,.76-62.39-4.46-129.2-15.5-186.81-39.53-90.93-37.92-148.74-104.69-159.64-204.4-8.83-80.75,10.4-161.81,53.91-230.14,2.81-4.42,3.77-9.23,3.67-14.54-1.35-75.5-.01-164.44,13.5-238.09,2.56-13.93,9.47-25.62,20.75-31.94,12.41-6.96,27.96-8.52,40.69-1.52,24.18,13.29,46.23,28.86,68.71,45.09,30.44,21.98,58.88,45.13,86.69,70.14,2.65,2.39,6.99,2.82,10.49,1.88,95.31-25.62,196-25.67,291.24.21,3.55.97,7.83-.29,10.29-2.36l53.22-44.86c32.1-25.08,64.51-48.56,99.76-69.03,12.44-7.23,27.63-7.23,40.76-.67,10.91,5.46,19.55,16.73,22.11,30.28,4.67,24.75,7.72,48.6,9.76,74.06,4.46,55.46,5.35,110.22,4.21,165.76-.16,7.56,1.72,12.49,5.56,18.64,40.02,63.98,58.65,138.94,53.25,214.46-1.73,24.16-5.98,46.74-13.59,69.43Z"
                    fill="#fdfbf7"
                  />
                </svg>
                <motion.span
                  className="relative z-10 font-['Gravitas_One'] select-none text-primary-500 text-3xl mt-1.5"
                  animate={{ rotate: [0, 360] }}
                  transition={{ duration: 12, repeat: Infinity, ease: "linear", repeatType: "loop" }}
                >
                  L
                </motion.span>
              </motion.span>
              <span
                className="w-6 h-6 text-md font-['Gravitas_One'] select-none flex items-center justify-center bg-base-50 text-primary-500 rounded-full translate-x-[2px] -translate-y-2"
                style={{ translateY: "-0.5rem" }}
              >
                <motion.span
                  className=""
                  animate={{ rotate: 360 }}
                  transition={{ duration: 1.5, repeat: Infinity, ease: [0.4, 0, 0.2, 1] }}
                >
                  o
                </motion.span>
              </span>
              <span
                className="w-6 h-6 text-md font-['Gravitas_One'] select-none flex items-center justify-center bg-base-50 text-primary-500 rounded-full translate-x-[2px] translate-y-1"
              >
                <motion.span
                  className=""
                  initial={{ rotate: -30 }}
                  animate={{ rotate: [-30, 330, 330, -30, -30] }}
                  transition={{
                    duration: 4,
                    repeat: Infinity,
                    ease: "easeInOut",
                    times: [0, 0.35, 0.5, 0.85, 1],
                  }}
                >
                  t
                </motion.span>
              </span>
              <span
                className="w-6 h-6 text-md font-['Gravitas_One'] select-none flex items-center justify-center bg-base-50 text-primary-500 rounded-full -translate-x-6 -translate-y-6"
              >
                <motion.span
                  className=""
                  initial={{ rotate: 195 }}
                  animate={{ rotate: -165 }}
                  transition={{ duration: 1, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
                >
                  t
                </motion.span>
              </span>
              <span
                className="w-6 h-6 text-md font-['Gravitas_One'] select-none flex items-center justify-center bg-base-50 text-primary-500 rounded-full -translate-x-5 -translate-y-2"
              >
                <motion.span
                  className=""
                  animate={{ rotate: 360 }}
                  transition={{ duration: 1.5, repeat: Infinity, ease: [0.4, 0, 0.2, 1] }}
                >
                  e
                </motion.span>
              </span>
              <span
                className="w-6 h-6 text-md font-['Gravitas_One'] select-none flex items-center justify-center bg-base-50 text-primary-500 rounded-full -translate-x-5 translate-y-1"
              >
                <motion.span
                  className=""
                  initial={{ rotate: -90 }}
                  animate={{ rotate: 30 }}
                  transition={{ duration: 1, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
                >
                  r
                </motion.span>
              </span>
              <span
                className="w-6 h-6 text-md font-['Gravitas_One'] select-none flex items-center justify-center bg-base-50 text-primary-500 rounded-full -translate-x-4 -translate-y-1"
              >
                <motion.span
                  className=""
                  initial={{ rotate: 15 }}
                  animate={{ rotate: -15 }}
                  transition={{ duration: 1, repeat: Infinity, ease: "easeInOut", repeatType: "reverse" }}
                >
                  y
                </motion.span>
              </span>
            </div>
          </Link>
        </h1>
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          className="flex flex-col justify-center gap-1.5 w-8 h-8 focus:outline-none"
          aria-label="メニュー"
        >
          <span className={`block h-0.5 w-full bg-primary-50 transition-all duration-300 ${isOpen ? "rotate-45 translate-y-2" : ""}`} />
          <span className={`block h-0.5 w-full bg-primary-50 transition-all duration-300 ${isOpen ? "opacity-0" : ""}`} />
          <span className={`block h-0.5 w-full bg-primary-50 transition-all duration-300 ${isOpen ? "-rotate-45 -translate-y-2" : ""}`} />
        </button>
      </div>

      {/* ドロップダウン */}
      {isOpen && (
        <>
          {/* オーバーレイ */}
          <div
            className="fixed inset-0 bg-base-50 z-40 top-16"
            style={{
              backgroundImage: 'radial-gradient(circle, rgba(227,0,127,0.2) 1px, transparent 1px), radial-gradient(circle, rgba(227,0,127,0.2) 1px, transparent 1px)',
              backgroundPosition: '2px 0, 6px 2px',
              backgroundSize: '8px 4px',
            }}
            onClick={handleClose}
          />
          {/* メニュー */}
          <nav className="container max-w-3xl mx-auto absolute top-full left-0 right-0 z-50 my-8 px-8">
            <div className="container max-w-3xl mx-auto bg-base-50 rounded-3xl max-h-[calc(100vh-8rem)] flex flex-col p-4">
              <ul className="px-4 py-4 overflow-y-auto">
                {NAV_GROUPS.map((group) => (
                  <li key={group.label} className="mb-4">
                    <p className="pr-4 py-1 text-base font-bold text-primary-500 uppercase tracking-widest">
                      {group.label}
                    </p>
                    <ul className="divide-y divide-primary-500">
                      {group.items.map((item) => (
                        <li key={item.to}>
                          <Link
                            to={item.to}
                            onClick={handleClose}
                            className={`block px-2 py-1 text-xs text-primary-500 hover:text-primary-500/50 transition-colors ${
                              location.pathname === item.to ? "font-bold" : ""
                            }`}
                          >
                            {item.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </>
      )}
    </header>
  );
};

export default Header;